var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10239",
    "data-name": "Group 10239",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    "data-name": "Path 4009",
    d: "M0,0H19V19H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4010",
    "data-name": "Path 4010",
    d: "M13.479,3a4.474,4.474,0,0,1,4.354,4.75c0,5.542-5.938,8.708-7.917,9.9C7.938,16.458,2,13.292,2,7.75A4.492,4.492,0,0,1,6.354,3,5.238,5.238,0,0,1,9.917,4.583,5.238,5.238,0,0,1,13.479,3ZM10.656,15.353a21.338,21.338,0,0,0,1.916-1.347c2.36-1.876,3.678-3.927,3.678-6.257a2.9,2.9,0,0,0-2.771-3.167A3.648,3.648,0,0,0,11.036,5.7L9.917,6.822,8.8,5.7A3.648,3.648,0,0,0,6.354,4.583,2.92,2.92,0,0,0,3.583,7.75c0,2.331,1.319,4.38,3.677,6.257a21.3,21.3,0,0,0,1.917,1.346c.237.15.471.293.739.453.268-.16.5-.3.739-.452Z",
    transform: "translate(-0.417 -0.625)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIcon);
export default __webpack_public_path__ + "static/media/favIcon.311c02157b81a41510ef4a92e5489eca.svg";
export { ForwardRef as ReactComponent };